import { TemplateAttributeMode } from './template-attribute-mode.enum';
import { TemplateAttributeType } from './template-attribute-type.enum';
export class TemplateAttribute {

  key: string;
  labelDictionaryKey: string;
  type: TemplateAttributeType;
  selectDefinitionUuid: string;
  mode: TemplateAttributeMode;
  required: boolean;
  cssStyle: string;
  sortOrder: number;
  choiceSelected = false;
  defaultValue: string;

  constructor(templateAttribute: any) {
    this.key = templateAttribute.key;
    this.labelDictionaryKey = templateAttribute.labelDictionaryKey;
    this.type = templateAttribute.type;
    this.mode = templateAttribute.mode;
    this.required = templateAttribute.required;
    this.cssStyle = templateAttribute.cssStyle;
    this.sortOrder = templateAttribute.sortOrder;
    this.defaultValue = templateAttribute.defaultValue;
    this.selectDefinitionUuid = templateAttribute.selectDefinitionUuid;
  }
}

